AUI().ready(
  /*
  This function gets loaded when all the HTML, not including the portlets, is
  loaded.
  */

  function () {}
);

Liferay.Portlet.ready(
  /*
  This function gets loaded after each and every portlet on the page.

  portletId: the current portlet's id
  node: the Alloy Node object of the current portlet
  */

  function (portletId, node) {}
);

Liferay.on(
  "allPortletsReady",

  /*
  This function gets loaded when everything, including the portlets, is on
  the page.
  */

  function () {}
);

// Funcionalidad barra de accesibilidad
var botonContraste = document.getElementById("botoncontraste");
var botonDisminuir = document.getElementById("botondisminuir");
var botonAumentar = document.getElementById("botonaumentar");
var mood = 1;
var tamañoBase = 16; // Tamaño base estándar (puedes ajustarlo)

// Función para obtener el tamaño actual
function obtenerTamañoActual() {
  return parseInt(
    getComputedStyle(document.documentElement).fontSize || tamañoBase
  );
}

// Contraste
botonContraste.addEventListener("click", function () {
  if (mood === 1) {
    document.body.classList.add("alto-contraste");
    mood = 2;
  } else {
    document.body.classList.remove("alto-contraste");
    mood = 1;
  }
});

// Reducir letra
botonDisminuir.addEventListener("click", function () {
  var tamañoActual = obtenerTamañoActual();
  if (tamañoActual > 10) {
    tamañoActual--;
    document.documentElement.style.fontSize = tamañoActual + "px";
  }
});

// Aumentar letra
botonAumentar.addEventListener("click", function () {
  var tamañoActual = obtenerTamañoActual();
  if (tamañoActual < 24) {
    // Límite máximo de 24px
    tamañoActual++;
    document.documentElement.style.fontSize = tamañoActual + "px";
  }
});

//Busqueda
$("#btnbuscar").on("click", function () {
  //   if (/\/$/.test(window.location.href)){

  // window.location = "/search?q=" + $("#barra_busqueda").val() + "&site=" + $("#btnbuscar").val() ;
  console.log("BOTON");
  barraSearch();
});

// Para que busque presionando "Enter"
$("#barra_busqueda").keyup(function (event) {
  if (event.keyCode === 13) {
    barraSearch();
  }
});

function barraSearch() {
  const siteUrl = $('#portalContext').data('site-url') || window.portalContext.SITE_URL;
  const searchTerm = $("#barra_busqueda").val().trim();

  if(searchTerm) {
      const searchUrl = `${siteUrl}/search?q=${encodeURIComponent(searchTerm)}`;
      console.log("Redirigiendo a:", searchUrl); // Debug
      window.location.href = searchUrl;
  }
}

$(".layouts.level-2 , .layouts.level-3").hide();
$(".level-1 .lfr-nav-item").click(function (e) {
  e.stopPropagation();
  $(this).children("ul").slideToggle();
});

// Transforma los menús de navegación en collapse (acordeones)
//Para cada item evalua si tiene hijos y de ser así agrega el span.
$(".layouts.level-1 li").each(function (index) {
  if ($(this).find(".layouts.level-2 , .layouts.level-3 ").length) {
    $(this).prepend("<span></span>");
    $(this).find("span").addClass("mas");
  } else {
    $(this).prepend("<span>&nbsp;&nbsp;</span>");
  }
});

// Hace el collpase
$(".layouts.level-1 li span").on("click", function () {
  if ($(".layouts.level-1 li span").hasClass("active")) {
    $(".layouts.level-1 li span").removeClass("active");
  } else {
    $(this).addClass("active");
  }
});

//-------
